import { render, staticRenderFns } from "./AssetManagementPlugin.vue?vue&type=template&id=775757e0&"
import script from "./AssetManagementPlugin.vue?vue&type=script&lang=ts&"
export * from "./AssetManagementPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports